 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"dashboard~extra":"dashboard~extra","dashboard":"dashboard","extra":"extra","pages":"pages"}[chunkId]||chunkId) + "." + {"chunk-01c32d3a":"694430c8","chunk-06d9e5e9":"02b77752","chunk-074694fa":"5c2124bf","chunk-0aa2bc0f":"dae3e81e","chunk-0d748c85":"a270e2b4","chunk-0d7b152c":"ab3f7a86","chunk-1633b25b":"397a2275","chunk-18946130":"3c96e4c2","chunk-22cf64ce":"eeae13c2","chunk-4b20db38":"64dd866d","chunk-4bc78b28":"316660f5","chunk-15aa61a7":"0d2a2e60","chunk-51c84beb":"edcb7bda","chunk-771a0e9a":"b93bad34","chunk-61e23eba":"28ace640","chunk-039f73b9":"bd6c16aa","chunk-33dc1d4a":"237e2ffe","chunk-452384d8":"a4c89928","chunk-96692f96":"f70ce229","chunk-750d0c9e":"13a3c7dc","chunk-285b0c14":"07a238f7","chunk-294b265d":"85bb546f","chunk-2d0b919a":"0c0ad4c0","chunk-2d0bced2":"65200e00","chunk-2d0c9517":"9fcea4a6","chunk-2d0ceb8d":"5d787f27","chunk-2d213d14":"3e5dc9d4","chunk-34836be6":"edd18abb","chunk-3a383e43":"002c504b","chunk-3bac1382":"1583143c","chunk-2d21e241":"cad80694","chunk-53566aa3":"6e708442","chunk-604dff5a":"0e63366a","chunk-0a8bd0c3":"a36354ae","chunk-66bb0f70":"4ba109a9","chunk-695e4d72":"62755242","chunk-6abbdb64":"bad4e31a","chunk-6fb80543":"8137e235","chunk-71e96465":"14aef376","chunk-74b9266b":"1323565f","chunk-76ff1337":"b9309b96","chunk-a0b1225c":"acfc39ac","chunk-ab7e0cd8":"3db9969d","chunk-b5a26930":"e746431e","chunk-e20e466e":"2c1cf1d8","chunk-49bc7d99":"a8e0e7db","chunk-f2e1cc14":"aba52134","dashboard~extra":"d61f43ac","dashboard":"3c3f420c","extra":"e2f55169","pages":"1107160d","chunk-490e6dd7":"f63b4971"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-01c32d3a":1,"chunk-06d9e5e9":1,"chunk-074694fa":1,"chunk-0aa2bc0f":1,"chunk-0d7b152c":1,"chunk-1633b25b":1,"chunk-18946130":1,"chunk-22cf64ce":1,"chunk-4b20db38":1,"chunk-4bc78b28":1,"chunk-15aa61a7":1,"chunk-51c84beb":1,"chunk-771a0e9a":1,"chunk-61e23eba":1,"chunk-039f73b9":1,"chunk-33dc1d4a":1,"chunk-452384d8":1,"chunk-96692f96":1,"chunk-750d0c9e":1,"chunk-34836be6":1,"chunk-3a383e43":1,"chunk-3bac1382":1,"chunk-53566aa3":1,"chunk-604dff5a":1,"chunk-0a8bd0c3":1,"chunk-66bb0f70":1,"chunk-695e4d72":1,"chunk-6abbdb64":1,"chunk-6fb80543":1,"chunk-71e96465":1,"chunk-74b9266b":1,"chunk-b5a26930":1,"chunk-e20e466e":1,"chunk-49bc7d99":1,"chunk-f2e1cc14":1,"dashboard~extra":1,"dashboard":1,"extra":1,"pages":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"dashboard~extra":"dashboard~extra","dashboard":"dashboard","extra":"extra","pages":"pages"}[chunkId]||chunkId) + "." + {"chunk-01c32d3a":"d02da762","chunk-06d9e5e9":"bd20eb15","chunk-074694fa":"d02da762","chunk-0aa2bc0f":"e9655486","chunk-0d748c85":"31d6cfe0","chunk-0d7b152c":"d02da762","chunk-1633b25b":"e9655486","chunk-18946130":"dbaaf2e7","chunk-22cf64ce":"3a1c6985","chunk-4b20db38":"19c6b061","chunk-4bc78b28":"ae0fffef","chunk-15aa61a7":"0e675b76","chunk-51c84beb":"1db3a975","chunk-771a0e9a":"74dd7f6d","chunk-61e23eba":"4c483983","chunk-039f73b9":"27cefaab","chunk-33dc1d4a":"1742c99d","chunk-452384d8":"1980cdf3","chunk-96692f96":"5a74a033","chunk-750d0c9e":"d02da762","chunk-285b0c14":"31d6cfe0","chunk-294b265d":"31d6cfe0","chunk-2d0b919a":"31d6cfe0","chunk-2d0bced2":"31d6cfe0","chunk-2d0c9517":"31d6cfe0","chunk-2d0ceb8d":"31d6cfe0","chunk-2d213d14":"31d6cfe0","chunk-34836be6":"cad2ddee","chunk-3a383e43":"d02da762","chunk-3bac1382":"73fce22a","chunk-2d21e241":"31d6cfe0","chunk-53566aa3":"d02da762","chunk-604dff5a":"7aa485f1","chunk-0a8bd0c3":"01b1eaab","chunk-66bb0f70":"d02da762","chunk-695e4d72":"b14a1a4c","chunk-6abbdb64":"a877a908","chunk-6fb80543":"faca859a","chunk-71e96465":"3e5476a4","chunk-74b9266b":"d02da762","chunk-76ff1337":"31d6cfe0","chunk-a0b1225c":"31d6cfe0","chunk-ab7e0cd8":"31d6cfe0","chunk-b5a26930":"d02da762","chunk-e20e466e":"d02da762","chunk-49bc7d99":"0e433876","chunk-f2e1cc14":"d02da762","dashboard~extra":"a80b77e4","dashboard":"1308be49","extra":"39a1f6c5","pages":"d5a9b1a2","chunk-490e6dd7":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
